module.exports = __webpack_public_path__ + "static/media/amr4.5f86f365.jpg";